<template>
    <div class="row">
        <div class="col s12">
            <fieldset>
                <span id="msg-span">{{ message }} </span>
                <div class="input-field col s10 m10 l10 xl10">
                    <select class="browser-default" v-model="itemSelected">
                        <option
                            v-for="(item, index) in itens"
                            :key="index"
                            :value="item"
                            :id="item.id"
                        >
                            {{ item.nome }}</option
                        >
                    </select>
                    <div class="input-field col2 m2 l2 xl2">
                        <a class="green-text" @click="showFormAddItem(true)">
                            <i class="material-icons" style="cursor: pointer;">
                                add
                            </i>
                        </a>
                    </div>
                </div>
            </fieldset>
            <div class="" v-if="showForm">
                <avaliacao-opcao-outros
                    :item="itemSelected"
                    :disabled="itemSelected.id != 11"
                    @add-item="addItem"
                />
            </div>
            <fieldset v-if="itensSelecionados && itensSelecionados.length">
                <legend>Itens Selecionados</legend>
                <base-card
                    v-for="(item, index) in itensSelecionados"
                    :key="index"
                >
                    <span slot="title">
                        {{ item.nome }}
                    </span>
                    <span slot="descricao">
                        {{ item.nota }}
                    </span>
                    <span slot="action">
                        <i class="material-icons" @click="remover(item)"
                            >delete</i
                        >
                    </span>
                </base-card>
                <div class="col s2 m2 l2 xl2">
                    <span style="font-size: 20px !important"
                        >Nota Total:{{ notaTotal }}</span
                    >
                </div>
                <div class="col s2 m2 l2 xl2">
                    <button class="btn" @click.prevent="avaliar()">
                        Avaliar
                    </button>
                </div>
            </fieldset>
        </div>
    </div>
</template>
<script>
import BaseCard from "./BaseCard.vue";
import AvaliacaoOpcaoOutros from "./AvaliacaoOpcaoOutros.vue";
import { mapActions, mapState } from "vuex";

const MENSAGEM_ID = 11;
const GRUPO_ID = 3;

export default {
    name: "AvaliacaoArtisticoCulturalOpcaoTecnico",
    components: { BaseCard, AvaliacaoOpcaoOutros },
    props: {
        itens: {
            type: Array
        }
    },
    data() {
        return {
            itensSelecionados: Array,
            showForm: false,
            itemOutro: Object,
            itemSelected: Object,
            notaTotal: 0
        };
    },
    computed: {
        ...mapState(["project"])
    },
    asyncComputed: {
        nota_max: {
            async get() {
                try {
                    let { data } = await this.$http.get(
                        `/api/avaliacao/notaMax/${GRUPO_ID}`
                    );

                    return data[0].nota_max;
                } catch (error) {
                    console.error(error);
                }
            }
        },
        message: {
            async get() {
                try {
                    let { data } = await this.$http.get(
                        `/api/mensagens/${MENSAGEM_ID}`
                    );
                    return data.mensagem;
                } catch (error) {
                    console.error(error);
                }
            }
        }
    },
    methods: {
        ...mapActions(["setAvaliacaoArtisticoCultural"]),
        clear() {
            this.$set(
                this,
                "itensAvaliados",
                this.project.avaliacao.avaliacao_artistico_cultural.artistico
            );
            this.$set(
                this,
                "gruposSelecionados",
                this.project.avaliacao.avaliacao_artistico_cultural
                    .naturezas_artistico
            );
        },
        init() {
            try {
                if (
                    this.project.avaliacao.avaliacao_artistico_cultural != undefined
                ) {
                    let avaliacao_tecnico = this.project.avaliacao
                        .avaliacao_artistico_cultural.tecnico;
                    this.$set(
                        this,
                        "itensSelecionados",
                        avaliacao_tecnico ? avaliacao_tecnico : []
                    );
                    this.$set(
                        this,
                        "notaTotal",
                        this.project.avaliacao.avaliacao_artistico_cultural.nota
                    );
                }
				else
					this.$set(
                        this,
                        "itensSelecionados", []);
            } catch (error) {
                console.log(error);
            }
        },
        async avaliar() {
            try {
                let tecnico = this.itensSelecionados;
                this.setAvaliacaoArtisticoCultural({
                    tecnico
                });

                let { data } = await this.$http.post(
                    "/api/avaliacaoArtisticoCultural",
                    {
                        id: this.project.avaliacao.id,
                        avaliacao_artistico_cultural: this.project.avaliacao
                            .avaliacao_artistico_cultural,
                        nota: this.notaTotal
                    }
                );
                showMsg(data.msg, 200);
            } catch (error) {
                console.error(error);
            }
        },
        toSum() {
            let total = 0;
            for (
                let i = 0;
                this.itensSelecionados && i < this.itensSelecionados.length;
                i++
            ) {
                let item = this.itensSelecionados[i];
                let nota = Number(item.nota);
                total = Number(total) + Number(nota);
                if (total > this.nota_max) {
                    total = this.nota_max;
                }
            }
            this.$set(this, "notaTotal", total.toFixed(2));
        },
        hasItem(item) {
            let index = this.itensSelecionados.findIndex(
                e => e.nome == item.nome
            );
            return index > -1;
        },
        remover(item) {
            let index = this.itensSelecionados.findIndex(i => i.id == item.id);
            this.itensSelecionados.splice(index, 1);
            this.toSum();
        },
        addItem(item) {
            if (!this.hasItem(item)) {
                this.$set(this, "itemSelected", item);
                this.$set(
                    this.itensSelecionados,
                    this.getSizeOfItensSelecionadosArray(),
                    item
                );
                this.toSum();
            } else showMsg("Item já incluso!");
            this.showFormAddItem(false);
        },
        getSizeOfItensSelecionadosArray() {
            return this.itensSelecionados.length;
        },
        getSizeOfItensArray() {
            return this.itens.length;
        },
        showFormAddItem(flag) {
            this.$set(this, "showForm", flag);
        }
    },
    mounted() {
        this.init();
    }
};
</script>
